import { toast } from "sonner";
import { http } from "@/lib/api";
import { useProfile } from "@/context/ProfileContext";
import { feelingColor } from "@/lib/buddy";
import { Checkbox } from "@/components/ui/checkbox";
import { BuddyAvatar } from "@/components/buddy/BuddyAvatar";
import { FeelingIcon } from "@/components/buddy/FeelingIcon";

export const TodayGoal = () => {
  const { buddy, todayCheckin, setTodayCheckin, setCheckinOpen } = useProfile();
  if (!buddy) return null;
  const tick = async (v) => {
    try { setTodayCheckin((await http.patch("/buddy/checkin/today", { goal_done: v })).data.checkin); }
    catch { toast.error("Couldn't update your goal. Try again."); }
  };

  return (
    <section className="mt-8 rounded-3xl border border-[#E6DEC3] p-5 flex flex-wrap items-center gap-4 bg-white/60" data-testid="today-goal-card">
      <BuddyAvatar buddy={buddy} className="w-12 h-12" testId="today-goal-avatar" />
      {todayCheckin ? (
        <>
          <span className="w-10 h-10 rounded-full grid place-items-center text-[#2C4A3E]" style={{ background: feelingColor(todayCheckin.feeling) }} data-testid="today-feeling"><FeelingIcon feeling={todayCheckin.feeling} /></span>
          <label className="flex items-center gap-3 flex-1 min-w-[200px] cursor-pointer">
            <Checkbox checked={todayCheckin.goal_done} onCheckedChange={(v) => tick(!!v)} data-testid="today-goal-checkbox" />
            <span className="text-sm"><span className="text-xs uppercase tracking-widest text-stone-500 block">Today's goal</span><span data-testid="today-goal-text" className={todayCheckin.goal_done ? "line-through text-stone-400" : "text-stone-700"}>{todayCheckin.goal}</span></span>
          </label>
          {todayCheckin.goal_done && <span className="text-sm font-display text-[#6B9080]" data-testid="today-goal-done">{buddy.name} is proud of you!</span>}
        </>
      ) : (
        <>
          <p className="flex-1 text-sm text-stone-600">{buddy.name} wants to know how you're feeling today.</p>
          <button onClick={() => setCheckinOpen(true)} data-testid="today-checkin-btn" className="px-5 py-2.5 rounded-full bg-[#2C4A3E] text-white text-sm">Check in</button>
        </>
      )}
    </section>
  );
};
